import React, { Component, Fragment } from 'react';

import serverClientUtil from '../../../../utils/serverClientUtil';


class NewItemsInnerSubmenuWap extends Component {
  render() {
    const { handleClick, textLabel, data, handleClickNested } = this.props;


    return (
      <Fragment>
        <button
          className="resetDefaultStyleBtn innerSubmenuBtn returnBtnWap"
          onClick={() => handleClick(textLabel, false)}
        >
          <span
            className="chevron chevronLeft right chevronLeftInnerSubmenuWap"
            style={{
              marginTop: '-2px',
            }}
          />
          <span>{textLabel}</span>
        </button>
        <ul className="resetUlStyles listContainer">
          {
            data.map(({ text, name, url, items, title, label,
                viewUrl
              }, index) => {;
              return <li
                key={`${(text || name || title || label)}-${index}`}
                className="itemListContainer"
                onClick={items && items.length > 0 ? () => handleClickNested([...items], (text || name || title || label)) : undefined}
              >
                {
                  items && items.length > 0
                    ? <span>{(text || name || title || label)}</span>
                    : <a href={serverClientUtil.getNavUrl(url || viewUrl)}>{(text || name || title || label)}</a>
                }
                {
                  items && items.length > 0 && (
                    <span
                      className="chevron chevronLeft left chevronLeftInnerSubmenuWap"
                      style={{
                        marginTop: '0',
                        position: 'absolute',
                      }}
                    />
                  )
                }
              </li>
            })
          }
        </ul>
      </Fragment>
    );
  }
}

export default NewItemsInnerSubmenuWap;
